// extracted by mini-css-extract-plugin
export default {"header":"app-events-GuestsTable-GuestsTable-module__qU2yteVIixL4EypPeHCv","guest-cell":"app-events-GuestsTable-GuestsTable-module__u2NFexTEFAcwAxJF9EkK"};